var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_vm.toggleAudio}},on),[_c('v-icon',{attrs:{"size":25,"color":"blue darken-2"}},[_vm._v(" mdi-play-circle-outline ")])],1)]}}])},[_vm._v(" Ouvir áudio ")])
}
var staticRenderFns = []

export { render, staticRenderFns }